import { ISplashScreen } from './interface';
import { PlatformSplashscreen } from './platform-splashscreen';

export const splashScreen: ISplashScreen = new PlatformSplashscreen();
